/**
 * Estado do cadastro em andamento (sessionStorage): sobrevive a recarga da
 * página no meio do funil. Nunca guarda imagem.
 */
const KEY = 'identila.demo.enrollment';

export type EnrollmentState = {
  enrollmentId: string;
  selfieDone: boolean;
  indexJobId: string | null;
};

export function readEnrollment(): EnrollmentState | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (
      parsed !== null &&
      typeof parsed === 'object' &&
      typeof (parsed as EnrollmentState).enrollmentId === 'string'
    ) {
      const state = parsed as Partial<EnrollmentState>;
      return {
        enrollmentId: state.enrollmentId!,
        selfieDone: state.selfieDone === true,
        indexJobId: typeof state.indexJobId === 'string' ? state.indexJobId : null,
      };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeEnrollment(state: EnrollmentState): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    /* storage indisponível: o funil ainda funciona com o state do router */
  }
}

export function clearEnrollment(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* idem */
  }
}
